// Helper för modaler i iframe-embed: be föräldersidan skrolla så att
// iframens topp hamnar i parent-viewporten — där vi placerar dialogen.
import { isEmbedMode } from "./embed-mode";

export function notifyParentModalOpen() {
  if (typeof window === "undefined") return;
  if (!isEmbedMode()) return;
  try {
    // y=0 = iframens topp i iframens egna koordinater. WP-sidan adderar
    // iframe.offsetTop och skrollar parent-fönstret dit.
    window.parent.postMessage({ type: "lovable:scrollto", y: 0 }, "*");
    window.parent.postMessage({ type: "lovable:scrollTo", top: 0 }, "*");
  } catch {
    // ignore
  }
}
